import { render, staticRenderFns } from "./SubHeading.vue?vue&type=template&id=50f7ae95&"
import script from "./SubHeading.vue?vue&type=script&lang=js&"
export * from "./SubHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports